import { Failure } from "./failure";
import { ErrorViolation } from "./error.model";

export class Unexpected extends Failure {
  public static getCode = "Unexpected";
  public static getMessage = "failureErrors.unexpected";

  constructor(
    public override code: string = Unexpected.getCode,
    public override message: string = Unexpected.getMessage,
  ) {
    super(code, message);
  }
}

export class AccessDenied extends Failure {
  public static getCode = "AccessDenied";
  public static getMessage = "failureErrors.accessDenied";

  constructor(
    public override code: string = AccessDenied.getCode,
    public override message: string = AccessDenied.getMessage,
  ) {
    super(code, message);
  }
}

export class NotFound extends Failure {
  public static getCode = "NotFound";
  public static getMessage = "failureErrors.notFound";

  constructor(
    public override code: string = NotFound.getCode,
    public override message: string = NotFound.getMessage,
  ) {
    super(code, message);
  }
}

export class NoInternetConnection extends Failure {
  public static getCode = "NoInternetConnection";
  public static getMessage = "failureErrors.noInternetConnection";

  constructor(
    public override code: string = NoInternetConnection.getCode,
    public override message: string = NoInternetConnection.getMessage,
  ) {
    super(code, message);
  }
}

export class ContentIsToBig extends Failure {
  public static getCode = "ContentIsToBig";
  public static getMessage = "failureErrors.contentIsToBig";

  constructor(
    public override code: string = ContentIsToBig.getCode,
    public override message: string = ContentIsToBig.getMessage,
  ) {
    super(code, message);
  }
}

export class Violations extends Failure {
  public static getCode = "Violations";
  public static getMessage = "failureErrors.violations";

  constructor(
    public violations: ErrorViolation[] = [],
    public override code: string = Violations.getCode,
    public override message: string = Violations.getMessage,
  ) {
    super(code, message);
  }

  public getViolationsByKey(): { [key: string]: ErrorViolation } {
    const violationsByKey: { [key: string]: ErrorViolation } = {};

    this.violations.forEach((v: ErrorViolation) => {
      violationsByKey[v.field] = v;
    });

    return violationsByKey;
  }
}

export class InactiveAccount extends Failure {
  public static getCode = "InactiveAccount";
  public static getMessage = "failureErrors.inactiveAccount";

  constructor(
    public override code: string = InactiveAccount.getCode,
    public override message: string = InactiveAccount.getMessage,
  ) {
    super(code, message);
  }
}

export class TooManyLoginAttempts extends Failure {
  public static getCode = "FailedAttempts";
  public static getMessage = "failureErrors.tooManyAttempts";

  constructor(
    public override code: string = TooManyLoginAttempts.getCode,
    public override message: string = TooManyLoginAttempts.getMessage,
  ) {
    super(code, message);
  }
}

export class BadCredentials extends Failure {
  public static getCode = "BadCredentials";
  public static getMessage = "failureErrors.badCredentials";

  constructor(
    public override code: string = BadCredentials.getCode,
    public override message: string = BadCredentials.getMessage,
  ) {
    super(code, message);
  }
}

export class FormErrors extends Failure {
  public static getCode = "FormErrors";
  public static getMessage = "failureErrors.formErrors";

  constructor(
    public override code: string = FormErrors.getCode,
    public override message: string = FormErrors.getMessage,
  ) {
    super(code, message);
  }
}

export class BadRequest extends Failure {
  public static getCode = "BadRequest";
  public static getMessage = "failureErrors.badRequest";

  constructor(
    public override code: string = BadRequest.getCode,
    public override message: string = BadRequest.getMessage,
  ) {
    super(code, message);
  }
}
